import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';

import TituloPagina from '../../components/layout/TituloPagina';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const SucessoStripe = props => {

    // Estado que controla a visibilidade do loading
    const [isProcessing, setIsProcessing] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');

    return (
        <>
            <TituloPagina titulo='Stripe Onboard' subtitulo={new Date().toLocaleString('pt-BR')} />
            
            <Grid container >
                <Grid item xs>
                    <Typography>Parabéns! Você concluiu a integração da sua Loja com a plataforma de pagamentos Stripe. Você já pode anunciar os seus produtos no Passarela 44 e vender muuuito!</Typography>
                </Grid>
            </Grid>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={loadingMessage}
            />
        </>
    )
}

export default connect(null, null)(SucessoStripe)